<template>
    <div
        id="assetMessage"
        :style="{ ...messageColors, ...(extendedStyle || {}) }"
        class="sc-message--text"
        v-if="getSrc()"
    >
        <span v-if="isGroupMessage" class="whatsapp-number-first" @click.stop="showWhatsappChatStarterModal = true">
            <a href="javascript:void(0)" :style="{ color: getWhatsappNumberColor() }"
                >{{ whatsappAuthorName }} - {{ whatsappAuthorNumber }}</a
            >
        </span>
        <div class="media-content-wrapper">
            <a
                :href="getSrc()"
                download
                target="_blank"
                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                :content="$t('message.download')"
            >
                <div v-if="getExt()" :class="`fi-${getExt()}`" class="fi">
                    <div class="fi-content" v-if="!isFilterAsset">{{ getExt() }}</div>
                    <div class="fi-content" v-if="isFilterAsset">
                        <div id="fi-data">
                            <p>{{ $t("message.type") }} : {{ getExt() }}</p>
                            <p>{{ $t("message.sender") }} : {{ !!message.raw ? message.raw.user.name : "" }}</p>
                        </div>
                    </div>
                </div>
                <a-icon type="cloud-download" v-else />
                <p class="asset-text mt-4">{{ getAssetName() }}</p>
            </a>
        </div>

        <div
            v-if="isGroupMessage"
            style="display: flex; flex-direction: row; justify-content: end; align-items: center; padding: 0 0.3rem"
        >
            <span class="sc-message-meta-new whatsapp-number" @click.stop="showWhatsappChatStarterModal = true">
                <a href="javascript:void(0)" :style="{ color: getWhatsappNumberColor() }"
                    >{{ whatsappAuthorName }} - {{ whatsappAuthorNumber }}</a
                >
            </span>
        </div>

        <span
            v-if="!message.isMail && message.data.meta"
            :class="message.author === 'me' ? 'received' : 'sent'"
            class="sc-message--meta"
            >{{ message.data.meta }}</span
        >

        <Modal2
            v-if="showWhatsappChatStarterModal"
            @cancel="showWhatsappChatStarterModal = false"
            :title="$t('message.whatsappChatStart')"
            :showFooter="false"
        >
            <WhatsappChatStarter
                :default-phone-number="whatsappAuthorNumber"
                channel-override
                phone-number-override
                @close="showWhatsappChatStarterModal = false"
                :default-name="whatsappAuthorName"
            />
        </Modal2>
    </div>
</template>

<script>
import log2 from "../../../utils/log2";
import _ from "lodash";
import Modal2 from "../../common/Modal2.vue";
import WhatsappChatStarter from "../../../views/Pages/Integrations/meta-leads/WhatsappChatStarter.vue";
import StringUtils from "../../../utils/StringUtils";

const log = log2("AssetMessage");
export default {
    name: "AssetMessage",
    props: {
        message: {
            type: Object,
            required: true,
        },
        extendedStyle: {
            type: Object,
        },
        messageColors: {
            type: Object,
            required: true,
        },
        isFilterAsset: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showWhatsappChatStarterModal: false,
        };
    },
    computed: {
        isGroupMessage() {
            return !!_.get(this.message, "raw.whatsappAuthor.author");
        },
        whatsappAuthorNumber() {
            return _.get(this.message, "raw.whatsappAuthor.author", "").replace(/[^0-9]/g, "");
        },
        whatsappAuthorName() {
            return _.get(this.message, "raw.whatsappAuthor.authorName", "");
        },
    },
    methods: {
        getAssetName() {
            const assetName = this.message?.raw?.asset?.name || "Dosyayı indir";
            return assetName;
        },
        getExt() {
            let asset = "";
            if (!!this.message.isMail) {
                asset = this.message.ext;
            } else {
                asset = this.message.raw.asset.ext;
            }
            return asset;
        },
        getSrc() {
            let asset = "";
            if (!!this.message.isMail) {
                asset = this.message;
            } else {
                asset = this.message.raw.asset;
            }
            const path = asset?.path;

            if (path) {
                const isWhatsapp = path.indexOf("whatsapp") !== -1;
                const isInstagram = path.indexOf("instagram") !== -1;
                const isMessenger = path.indexOf("messenger") !== -1;
                const isTelegram = path.indexOf("telegram") !== -1;
                const isLinkedin = path.indexOf("linkedin") !== -1;

                const src =
                    isWhatsapp || isInstagram || isTelegram || isMessenger || isLinkedin
                        ? `https://static.supsis.live/${path}`
                        : asset.v2Format && asset.cdnUrl
                        ? asset.cdnUrl
                        : `https://static.supsis.live/${path + asset._id + (asset.ext ? "." + asset.ext : "")}`;
                log("src", src);
                return src;
            } else {
                log("src path not found", this.message?.raw?.asset);
                return null;
            }
        },
        getWhatsappNumberColor() {
            if (this.isGroupMessage) {
                const colors = ["#1a5fb4", "#813d9c", "#c64600", "#2ec27e", "#e01b24", "#3584e4", "#9141ac", "#f5c211"];
                const index = Math.abs(this.hashCode(this.whatsappAuthorNumber)) % colors.length;
                return colors[index];
            }
            return this.messageColors.color;
        },
        hashCode(str) {
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                const char = str.charCodeAt(i);
                hash = (hash << 5) - hash + char;
                hash = hash & hash; // Convert to 32bit integer
            }
            return hash;
        },
    },
    mounted() {},
    components: {
        Modal2,
        WhatsappChatStarter,
    },
};
</script>

<style lang="scss" scoped>
@import "~css-file-icons";

#assetMessage {
    .media-content-wrapper {
        margin: 4px;

        a {
            display: flex;
            gap: 5px;
            flex-direction: row;
            align-items: center;
            padding: 5px;

            &:hover {
                p {
                    border-bottom: 1px solid #000;
                }
            }

            p {
                border-bottom: 1px solid transparent;
                margin-bottom: 0;
                max-width: 150px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .media-content-text {
            margin-bottom: 0;
            font-family: Poppins, monospace;
            margin-top: 6px;
            font-size: 12px;
            font-weight: 400;
            text-align: center;
        }
    }

    .received {
        color: #222222;
    }

    .sent {
        color: #ffffff;
    }

    .fi-content {
        width: auto;
        font-size: 11px;
    }

    #fi-data {
        position: absolute;
        color: black;
        left: 40px;
        top: -6px;
        font-size: x-small;
        width: max-content;
        display: flex;
        flex-direction: column-reverse;
        line-height: 10px;
    }
}

.whatsapp-number {
    cursor: pointer;

    a {
        text-decoration: underline;
    }
}

.whatsapp-number-first {
    cursor: pointer;
    font-size: smaller;
    font-weight: 200;
    letter-spacing: 2px;

    a {
        &:hover {
            text-decoration: underline;
        }
    }

    padding: 5px;
}

.sc-message-meta-new {
    font-size: 8px;
    font-weight: 300;
    color: white;
    text-align: right;
    border-radius: 6px;
    text-transform: uppercase;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 0px !important;
    margin: 5px !important;
    margin-right: 14px !important;
    margin-bottom: 14px !important;
}
</style>
